import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
// Eliminada la importación de logo.svg
import NetworkBackground from './NetworkBackground';
import MiniFeedEventos from './MiniFeedEventos';
import LoginModal from './LoginModal';
import { useAuth } from '../contexts/AuthContext';
import { FaUser, FaSignOutAlt } from 'react-icons/fa';

const menuItems = [
  { label: 'INICIAR SESIÓN', href: '#login', isLogin: true },
  { label: 'MEMBRESÍA GOLD', href: '/membresias' },
  { label: 'CLUB EMPRESARIAL', href: '/club-empresarial' },
  { label: 'NETWORKING ESTRATÉGICO', href: '/networking-estrategico', noPage: true },
  { label: 'CONCEPT STORE', href: '/concept-store' },
  { label: 'PODCAST', href: '/podcast', noPage: true },
  { label: 'CONTÁCTO', href: '/contacto' },
];

export default function Header() {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const menuRef = useRef(null);
  const menuButtonRef = useRef(null);
  const location = useLocation();

  // const closeMenu = () => setMenuOpen(false);

  const handleMenuClick = (href, isLogin = false) => {
    if (isLogin) {
      setLoginModalOpen(true);
      setMenuOpen(false);
      return;
    }
    if (href === '#footer-contacto') {
      const el = document.getElementById('footer-contacto');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        setMenuOpen(false);
        return;
      }
    }
    setMenuOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    setMenuOpen(false);
  };

  const handleUserClick = () => {
    navigate('/dashboard');
    setMenuOpen(false);
  };

  // Cerrar menú al hacer clic fuera
  useEffect(() => {
    if (!menuOpen) return;
    function handleClickOutside(event) {
      if (
        (menuRef.current && menuRef.current.contains(event.target)) ||
        (menuButtonRef.current && menuButtonRef.current.contains(event.target))
      ) {
        return;
      }
      setMenuOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <>
    <header className="header">
        <NetworkBackground />
      {/* Barra superior solo visible en móvil/tablet */}
      <div className="mobile-bar">
          <Link to="/">
            <img src="/images/RecomiendaT-logo.png" alt="Logo" className="logo-img-mobile" />
          </Link>
          <MiniFeedEventos />
          <button
            className="menu-toggle"
            ref={menuButtonRef}
            onClick={() => setMenuOpen((open) => !open)}
          >
          MENU
        </button>
      </div>
      {/* Layout escritorio */}
      <div className="header-row">
        <nav className={`nav-vertical`}>
          <ul>
            {menuItems.map((item) => (
              <li key={item.label}>
                {item.label === 'CONTÁCTO' ? (
                  <a
                    href="#footer-contacto"
                    onClick={e => {
                      e.preventDefault();
                      handleMenuClick('#footer-contacto');
                    }}
                  >
                    {item.label}
                  </a>
                ) : item.isLogin ? (
                  isAuthenticated ? (
                    <div className="user-menu">
                      <div className="user-info" onClick={handleUserClick} title="Ir al Dashboard">
                        <FaUser className="user-icon" />
                        <span className="user-name">{user?.nombre || 'Usuario'}</span>
                      </div>
                      <button
                        className="menu-logout-btn"
                        onClick={handleLogout}
                      >
                        <FaSignOutAlt />
                        CERRAR SESIÓN
                      </button>
                    </div>
                  ) : (
                    <button
                      className="menu-login-btn"
                      onClick={() => handleMenuClick(item.href, true)}
                    >
                      {item.label}
                    </button>
                  )
                ) : item.noPage ? (
                  <span
                    className="menu-item-disabled"
                    onClick={() => handleMenuClick(item.href)}
                    style={{ cursor: 'default', opacity: 0.6 }}
                  >
                    {item.label}
                  </span>
                ) : (
                  <Link
                    to={item.href}
                    onClick={() => handleMenuClick(item.href)}
                    className={location.pathname === item.href ? 'active' : ''}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
        <div className="logo-center">
            <Link to="/">
              <img src="/images/RecomiendaT-logo.png" alt="Logo" className="logo-img" />
            </Link>
          </div>
        <MiniFeedEventos />
      </div>
      </header>
      {/* Menú móvil/tablet (dropdown) renderizado fuera del header */}
      {menuOpen && (
        <nav className="nav-mobile-dropdown" ref={menuRef}>
          <ul>
            {menuItems.map((item) => (
              <li key={item.label}>
                {item.label === 'CONTÁCTO' ? (
                  <a
                    href="#footer-contacto"
                    onClick={e => {
                      e.preventDefault();
                      handleMenuClick('#footer-contacto');
                    }}
                  >
                    {item.label}
                  </a>
                ) : item.isLogin ? (
                  isAuthenticated ? (
                    <div className="user-menu-mobile">
                      <div className="user-info" onClick={handleUserClick} title="Ir al Dashboard">
                        <FaUser className="user-icon" />
                        <span className="user-name">{user?.nombre || 'Usuario'}</span>
                      </div>
                      <button
                        className="menu-logout-btn"
                        onClick={handleLogout}
                      >
                        <FaSignOutAlt />
                        CERRAR SESIÓN
                      </button>
                    </div>
                  ) : (
                    <button
                      className="menu-login-btn"
                      onClick={() => handleMenuClick(item.href, true)}
                    >
                      {item.label}
                    </button>
                  )
                ) : item.noPage ? (
                  <span
                    className="menu-item-disabled"
                    onClick={() => handleMenuClick(item.href)}
                    style={{ cursor: 'default', opacity: 0.6 }}
                  >
                    {item.label}
                  </span>
                ) : (
                  <Link
                    to={item.href}
                    onClick={() => handleMenuClick(item.href)}
                    className={location.pathname === item.href ? 'active' : ''}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
      )}
      
      {/* Modal de inicio de sesión */}
      <LoginModal 
        isOpen={loginModalOpen} 
        onClose={() => setLoginModalOpen(false)} 
      />
    </>
  );
} 